<template>
  <div>
    <div class="dashboard p-4">
      <h1>
        Infodata, sales by channel
        <span v-if="activeTab === 'current' && loading">(loading...)</span>
      </h1>
      <hr class="my-2" />

      <!-- Tabs -->
      <div class="tabs mb-4">
        <button
          :class="['tab-button', { active: activeTab === 'current' }]"
          @click="activeTab = 'current'"
        >
          Current Stats
        </button>
        <button
          :class="['tab-button', { active: activeTab === 'compare' }]"
          @click="activeTab = 'compare'"
        >
          Compare Stats
        </button>
      </div>

      <!-- Tab Content -->
      <div class="tab-content">
        <div v-if="activeTab === 'current'" class="tab-pane active">
          <CurrentProductStats ref="currentStats" />
        </div>
        <div v-if="activeTab === 'compare'" class="tab-pane active">
          <ProductStatsCompare ref="compareStats" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CurrentProductStats from "@/components/CurrentProductStats.vue";
import ProductStatsCompare from "@/components/ProductStatsCompare.vue";

export default {
  name: "InfoPage",
  components: {
    CurrentProductStats,
    ProductStatsCompare
  },
  data() {
    return {
      activeTab: "current",
      loading: false
    };
  },
  methods: {
    logout() {
      this.$store.dispatch("auth/logOut");
      this.$router.push("/");
    }
  }
};
</script>

<style scoped>
.tabs {
  display: flex;
  gap: 1rem;
  border-bottom: 2px solid #dee2e6;
}

.tab-button {
  padding: 0.75rem 1.5rem;
  background-color: transparent;
  border: none;
  border-bottom: 3px solid transparent;
  cursor: pointer;
  font-size: 1rem;
  font-weight: 500;
  color: #666;
  transition: all 0.3s ease;
}

.tab-button:hover {
  color: #333;
}

.tab-button.active {
  color: #007bff;
  border-bottom-color: #007bff;
}

.tab-content {
  margin-top: 1rem;
}

.tab-pane {
  display: none;
}

.tab-pane.active {
  display: block;
}
</style>
